import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';
import { Playlist, MatchEvent, PlaylistItem } from '../../models';
import { PlaylistService } from '../../services';

@Component({
  selector: 'add-to-playlist-dialog',
  templateUrl: './add-to-playlist-dialog.html',
  styles: []
})
export class AddToPlaylistDialogComponent implements OnInit {
  selectedPlaylist: Playlist;
  playlists: Playlist[];

  constructor(
    public dialogRef: MatDialogRef<AddToPlaylistDialogComponent>,
    public playlistService: PlaylistService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    console.info('[AddToPlaylistDialog]:init', this.data);
    this.playlists = this.data.playlists;
  }

  onAddClick(): void {
    console.info('Entered: ', this.selectedPlaylist);

    const codeEvents = this.data.codeEvents as MatchEvent[];

    const mappedEvents = codeEvents.map(e => {
      const comments = e.comments ? e.comments : '';

      return {
        lagSeconds: e.lagSeconds,
        leadSeconds: e.leadSeconds,
        name: e.eventType,
        seconds: e.seconds,
        comments
      } as PlaylistItem;
    });

    const playlist: Playlist = {
      ...this.selectedPlaylist,
      items: [...mappedEvents, ...this.selectedPlaylist.items]
    };

    this.playlistService.update(playlist);
    this.dialogRef.close(playlist);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
